module.exports = __webpack_public_path__ + "img/blue_128.0571782a.png";